"use client";
import React, { useState, useRef, useEffect } from "react";
import clsx from "clsx";

export function OverNote({ overContent, inlineContent }) {
  const [isActive, setActive] = useState(false);
  const noteRef = useRef(null);

  useEffect(() => {
    if (!noteRef.current) {
      return;
    }

    const node = noteRef.current;
    const bounds = node.getBoundingClientRect();
    const rightx = bounds.x + bounds.width;

    if (isActive && rightx > window.innerWidth) {
      node.style.transform = `translateX(${window.innerWidth - rightx - 5}px)`;
    }
    if (!isActive) {
      node.style.transform = "none";
    }
  }, [isActive]);

  const showOverContent = () => setActive(true);

  const hideOverContent = () => setActive(false);

  return (
    <span
      className="group inline-block relative hover:shadow-3xl"
      onMouseEnter={showOverContent}
      onMouseLeave={hideOverContent}
      style={{
        marginTop: 0,
        marginBottom: 0,
      }}
    >
      <span
        ref={noteRef}
        className={clsx(
          "px-1 py-2 absolute shadow-xl bottom-5 border-2 border-dotted border-sc-try-color left-0 bg-sc-code-bg-color max-w-prose whitespace-normal",
          isActive && overContent ? "block" : "hidden",
          { "z-20": isActive },
        )}
        style={{
          minWidth: "40ch",
        }}
      >
        {overContent}
      </span>
      <span
        className={clsx(
          "relative border-2 border-dotted group-hover:bg-sc-code-bg-color border-sc-try-color group-hover:shadow-xl",
          {
            "overnote-hide-top-shadow": isActive,
            "z-40": isActive,
          },
        )}
        style={{
          borderTopColor: isActive ? "var(--background-main)" : null,
          borderTopStyle: isActive ? "solid" : "dotted",
        }}
      >
        {inlineContent}
      </span>
    </span>
  );
}
